import React, { useCallback } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import withCurrentGallectionSubfolders, {
  WithCurrentGallectionSubfoldersProps,
} from '../../_hocs/withCurrentGallectionSubfolders';
import {
  moveGallectionToPosition as moveGallectionToPositionAction,
  MoveGallectionToPositionPayload,
} from '../../actions';
import { DndSortable, DndSortableElement } from '../../../Dnd/DndSortable';
import { DraggableType } from '../../../types/dnd';
import SubfolderSlider from '../SubfolderSlider';
import ManageableSubfolder from './ManageableSubfolder';

import manageableSubfolderSliderStyles from './ManageableSubfolderSlider.scss';

export interface Props {}

const enhance = compose(
  withCurrentGallectionSubfolders,
  connectMediaStore(null, {
    moveGallectionToPosition: moveGallectionToPositionAction,
  }) as any
) as any;

type CombinedProps = Props &
  WithCurrentGallectionSubfoldersProps & {
    moveGallectionToPosition(payload: MoveGallectionToPositionPayload): any;
  };

export const ManageableSubfolderSlider: React.FC<CombinedProps> = ({
  subfolders,
  moveGallectionToPosition,
}) => {
  const onDrop = useCallback(
    (folderId: number, position: number) =>
      moveGallectionToPosition({
        folderId,
        position,
        moveType: 'papiOnly',
      }),
    [moveGallectionToPosition]
  );
  const onDragOver = useCallback(
    (folderId: number, position: number) =>
      moveGallectionToPosition({
        folderId,
        position,
        moveType: 'streamOnly',
      }),
    [moveGallectionToPosition]
  );

  if (!subfolders.length) {
    return null;
  }

  const existingGallectionNames = subfolders.map(gallection => gallection.name);
  return (
    <DndSortable onDrop={onDrop} onDragOver={onDragOver}>
      {({ draggedElementId, ...dndProps }) => (
        <SubfolderSlider disableArrows={!!draggedElementId}>
          {subfolders.map((subfolder, index) => (
            <DndSortableElement
              dndType={DraggableType.MEDIA_MANAGER_SLIDER_GALLECTION}
              id={subfolder.folderId}
              key={subfolder.folderId}
              position={index}
              {...dndProps}
            >
              {sortableOptions => (
                <div
                  ref={sortableOptions.ref}
                  className={classnames(
                    draggedElementId === subfolder.folderId &&
                      manageableSubfolderSliderStyles['dragging']
                  )}
                >
                  <ManageableSubfolder
                    key={index}
                    subfolder={subfolder}
                    existingGallectionNames={existingGallectionNames}
                  />
                </div>
              )}
            </DndSortableElement>
          ))}
        </SubfolderSlider>
      )}
    </DndSortable>
  );
};
ManageableSubfolderSlider.displayName = 'SubfolderSliderSelector';

export default enhance(ManageableSubfolderSlider) as React.ComponentType<Props>;
